module.exports = __webpack_public_path__ + "static/img/1.8bc71db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresarial-Fraude-Empleados/1.png
// module id = 5ME6
// module chunks = 0